import { useEffect, useState } from "react";
import api from "../api";

import { motion } from "framer-motion";

export default function SecurityDashboard() {

  const [logs, setLogs] =
    useState([]);

  const [authLogs, setAuthLogs] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  // =====================
  // FETCH
  // =====================

  const fetchData = async () => {

    try {

      const [logsRes, authRes] =
        await Promise.all([
          api.get("/logs"),
          api.get("/auth/auth-logs")
        ]);

      setLogs(
        logsRes.data || []
      );

      setAuthLogs(
        authRes.data || []
      );

    } catch (err) {

      if (
        err.response?.status === 401
      ) {

        localStorage.clear();

        window.location.href = "/";

      }

    } finally {

      setLoading(false);

    }
  };

  // =====================
  // BADGE
  // =====================

  const badge = (status) => {

    if (
      status === "VALIDE" ||
      status === "SUCCESS"
    ) {

      return "bg-green-100 text-green-700";

    }

    return "bg-red-100 text-red-700";
  };

  // =====================
  // LOADING
  // =====================

  if (loading) {

    return (
      <p className="p-4 md:p-6">
        Chargement...
      </p>
    );

  }

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 bg-gray-100 min-h-[100dvh]">

      <div className="max-w-7xl mx-auto space-y-4 md:space-y-6">

        {/* HEADER */}
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
          Dashboard Sécurité
        </h1>

        {/* QR LOGS */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="bg-white p-3 md:p-6 rounded-2xl shadow"
        >

          <h2 className="text-lg md:text-xl font-semibold text-gray-700 mb-4">
            Vérifications QR
          </h2>

          {logs.length === 0 ? (

            <p className="text-gray-400">
              Aucune donnée disponible
            </p>

          ) : (

            <div className="overflow-x-auto">

              <table className="min-w-[700px] w-full text-sm">

                <thead className="bg-gray-100 text-gray-600">

                  <tr>

                    <th className="p-3 text-left whitespace-nowrap">
                      Facture
                    </th>

                    <th className="p-3 text-left whitespace-nowrap">
                      IP
                    </th>

                    <th className="p-3 text-left whitespace-nowrap">
                      Statut
                    </th>

                    <th className="p-3 text-left whitespace-nowrap">
                      Date
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {logs.map((log) => (

                    <tr
                      key={log.id}
                      className="border-t hover:bg-gray-50 transition"
                    >

                      <td className="p-3 font-medium whitespace-nowrap">
                        #{log.facture_id}
                      </td>

                      <td className="p-3 whitespace-nowrap">
                        {log.ip_address}
                      </td>

                      <td className="p-3 whitespace-nowrap">

                        <span
                          className={`px-2 py-1 text-xs rounded ${badge(log.statut)}`}
                        >
                          {log.statut}
                        </span>

                      </td>

                      <td className="p-3 whitespace-nowrap">
                        {new Date(
                          log.created_at
                        ).toLocaleString()}
                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          )}

        </motion.div>

        {/* AUTH LOGS */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="bg-white p-3 md:p-6 rounded-2xl shadow"
        >

          <h2 className="text-lg md:text-xl font-semibold text-gray-700 mb-4">
            Connexions
          </h2>

          {authLogs.length === 0 ? (

            <p className="text-gray-400">
              Aucune donnée disponible
            </p>

          ) : (

            <div className="overflow-x-auto">

              <table className="min-w-[800px] w-full text-sm">

                <thead className="bg-gray-100 text-gray-600">

                  <tr>

                    <th className="p-3 text-left whitespace-nowrap">
                      Utilisateur
                    </th>

                    <th className="p-3 text-left whitespace-nowrap">
                      IP
                    </th>

                    <th className="p-3 text-left whitespace-nowrap">
                      Statut
                    </th>

                    <th className="p-3 text-left whitespace-nowrap">
                      Date
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {authLogs.map((log) => (

                    <tr
                      key={log.id}
                      className="border-t hover:bg-gray-50 transition"
                    >

                      <td className="p-3 font-medium break-all">
                        {log.email}
                      </td>

                      <td className="p-3 whitespace-nowrap">
                        {log.ip_address}
                      </td>

                      <td className="p-3 whitespace-nowrap">

                        <span
                          className={`px-2 py-1 text-xs rounded ${badge(log.statut)}`}
                        >
                          {log.statut}
                        </span>

                      </td>

                      <td className="p-3 whitespace-nowrap">
                        {new Date(
                          log.created_at
                        ).toLocaleString()}
                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          )}

        </motion.div>

      </div>

    </div>
  );
}